module.exports = __webpack_public_path__ + "img/1.adf864d2.png";